import { render, staticRenderFns } from "./record.vue?vue&type=template&id=3d98e68c&scoped=true"
import script from "./record.vue?vue&type=script&lang=ts"
export * from "./record.vue?vue&type=script&lang=ts"
import style0 from "./record.vue?vue&type=style&index=0&id=3d98e68c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d98e68c",
  null
  
)

export default component.exports